var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.455,
    height: 74.008,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    transform: "translate(1 1.031)",
    fill: "none",
    stroke: "#7A89A0",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15804",
    d: "M76.326 61.496H30.642V22.668",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15805",
    d: "M41.453 60.831V47.559h5.922v13.272",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15806",
    d: "M54.284 60.83V41.867h5.922V60.83",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15807",
    d: "M67.114 60.83V36.814h5.922V60.83",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15808",
    d: "m42.769 42.407 8.883-8.883 4.935 4.935 10.856-10.857 2.961 2.961 6.58-6.58",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7456",
    strokeMiterlimit: 10,
    d: "M30.596 22.997h4.336"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7457",
    strokeMiterlimit: 10,
    d: "M30.866 30.807h4.336"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7458",
    strokeMiterlimit: 10,
    d: "M30.866 38.624h4.336"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7459",
    strokeMiterlimit: 10,
    d: "M30.866 46.434h4.336"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7460",
    strokeMiterlimit: 10,
    d: "M30.866 54.251h4.336"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15809",
    d: "M72.378 23.325h5.264v5.264",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15810",
    d: "M16.45 61.489V10.166h76.984v51.323",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7461",
    strokeMiterlimit: 10,
    d: "M3.454 48.658v6.909"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7462",
    strokeMiterlimit: 10,
    d: "M6.909 52.112H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7463",
    strokeMiterlimit: 10,
    d: "M81.59.132v4.606"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7464",
    strokeMiterlimit: 10,
    d: "M83.893 2.435h-4.606"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4047",
    cx: 2.303,
    cy: 2.303,
    r: 2.303,
    transform: "translate(1.316 20.365)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4048",
    cx: 3.619,
    cy: 3.619,
    r: 3.619,
    transform: "translate(100.671 21.681)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15811",
    d: "M17.831 0c2.106.066 1.974 4.277 4.079 4.343S24.141.2 26.247.263s1.974 4.277 4.084 4.343S32.575.461 34.68.527s1.969 4.273 4.075 4.342",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15812",
    d: "M102.316 59.844c0-1.645 3.29-1.645 3.29-3.29s-3.29-1.645-3.29-3.29 3.29-1.645 3.29-3.29-3.29-1.645-3.29-3.29 3.29-1.645 3.29-3.29",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7465",
    d: "M.455 71.978h109"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDate);
export default __webpack_public_path__ + "static/media/no_date.80573552570cd52817ad4ce8b4e6e512.svg";
export { ForwardRef as ReactComponent };